import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const fmtUSD = (n: number | string | null | undefined) => {
  const v = Number(n ?? 0);
  return (v < 0 ? "-" : "") + "$" + Math.abs(Math.round(v)).toLocaleString();
};
